import React from 'react';
import { User, CheckCircle, XCircle, Clock } from 'lucide-react';

interface StatsSummaryProps {
	total: number;
	verified: number;
	failed: number;
	pending: number;
	isLoading?: boolean;
}

const StatsSummary: React.FC<StatsSummaryProps> = ({ total, verified, failed, pending, isLoading = false }) => {
	return (
		<div className="mx-auto py-6 grid grid-cols-1 md:grid-cols-4 gap-6">
			{[
				{
					label: 'Total Verifications',
					value: total,
					icon: <User className="text-ghana-gold w-5 h-5" />,
				},
				{
					label: 'Verified',
					value: verified,
					icon: <CheckCircle className="text-green-600 w-5 h-5" />,
				},
				{
					label: 'Failed',
					value: failed,
					icon: <XCircle className="text-red-600 w-5 h-5" />,
				},
				{
					label: 'Pending',
					value: pending,
					icon: <Clock className="text-yellow-600 w-5 h-5" />,
				},
			].map(({ label, value, icon }) => (
				<div
					key={label}
					className="bg-white p-6 rounded-xl shadow-sm flex justify-between items-center"
				>
					<div>
						<p className="text-sm text-gray-600">{label}</p>
						{isLoading ? (
							<div className="text-3xl font-bold">
								<div className="h-8 bg-gray-200 rounded animate-pulse w-16"></div>
							</div>
						) : (
							<p className="text-3xl font-bold">{value}</p>
						)}
					</div>
					{icon}
				</div>
			))}
		</div>
	);
};

export default StatsSummary;
